import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift } from '@fortawesome/pro-regular-svg-icons/faGift';

import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import { messages } from '../../../../../../components/is-gift-indicator/messages';

import style from './gift-indicator.module.less';

export const GiftIndicator = () => {
  return (
    <div className={style['gift-indicator']}>
      <FontAwesomeIcon className={style.icon} icon={faGift} />
      <Text element='span' textType={TextType.Caption} value={messages.giftIndicator} />
    </div>
  );
};
